import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { OfferSelectionCardModel } from '@flocasts/experience-service-types'
import { combineLatest, map } from 'rxjs'
import {
  EXP_NEW_PLANS_PAGE_ID,
  EXP_NEW_PLANS_PAGE_VARIATION_1,
  EXP_NEW_PLANS_PAGE_VARIATION_2
} from 'src/app/shared/experimentation/experiment.model'
import { ExperimentationService } from 'src/app/shared/experimentation/experimentation.service'
import { SiteIds } from 'src/app/shared/models/site.model'
import { ProductService } from 'src/app/shared/services/product.service'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { VerticalService } from 'src/app/singleton-services/vertical.service'

@Component({
  selector: 'flo-offer-selection-card',
  templateUrl: './offer-selection-card.component.html',
  styleUrls: ['./offer-selection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferSelectionCardComponent implements OnInit {
  constructor(
    private readonly productService: ProductService,
    private readonly verticalService: VerticalService,
    private readonly experiementService: ExperimentationService
  ) {}

  ngOnInit(): void {
    this.is2025Layout$.subscribe(is2025Layout => {
      this.is2025Layout = is2025Layout
    })
  }
  /**
   * Card displaying offer pricing information
   */
  @Input()
  offer: OfferSelectionCardModel

  /**
   * Indicates if the offer is selected by the user
   */
  @Input()
  isSelected = false

  @Input()
  displayProduct = false

  readonly trackById = trackById

  get isMonthly() {
    return this.offer.heading === 'Monthly Plan'
  }

  private is2025Layout$ = combineLatest([
    this.verticalService.siteId$,
    this.experiementService.isInVariation(EXP_NEW_PLANS_PAGE_ID, EXP_NEW_PLANS_PAGE_VARIATION_1),
    this.experiementService.isInVariation(EXP_NEW_PLANS_PAGE_ID, EXP_NEW_PLANS_PAGE_VARIATION_2)
  ]).pipe(map(([siteId, var1, var2]) => siteId === SiteIds.FLORACING && (var1 || var2)))

  public is2025Layout = false

  public isWrestlingPromoActive$ = combineLatest([
    this.productService.isWrestlingGiftPromoActive$,
    this.verticalService.siteId$
  ]).pipe(
    map(([isWrestlingGiftPromoActive, siteId]) => {
      return isWrestlingGiftPromoActive && siteId === SiteIds.FLOWRESTLING
    })
  )
}
